import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './checkbox.scss';

const Checkbox = ({
  isToggled = false,
  handleChange = () => null,
  isSlider = false,
  disabled = false,
  dataTestId = 'checkbox',
  ariaLabel = 'checkbox',
}) => {
  const [isToggledState, setIsToggledState] = useState(isToggled);

  useEffect(() => {
    if (isToggled !== isToggledState) setIsToggledState(isToggled);
  }, [isToggled]);

  const onChange = (event) => {
    setIsToggledState(event.target.checked);
    handleChange(event.target.checked);
  };

  return (
    <div className={classNames({ 'checkbox-slider': isSlider })}>
      <label className={classNames({ 'switch-toggle': isSlider })}>
        <input
          type='checkbox'
          data-testid={dataTestId}
          aria-label={ariaLabel}
          checked={isToggledState}
          className={classNames({ checked: isToggledState })}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={classNames({
            'slider round': isSlider,
            'not-active': disabled,
          })}
        ></span>
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  isToggled: PropTypes.bool,
  handleChange: PropTypes.func,
  isSlider: PropTypes.bool,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default Checkbox;
